module.exports = __webpack_public_path__ + "media/images/services-img-3-7ef859b1b9cef2e38dc005a7376797bc.png";